import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { BarsicService } from 'src/app/services/barsic.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-create-barsic-factor',
  templateUrl: './create-barsic-factor.component.html',
  styles: [
  ]
})
export class CreateBarsicFactorComponent implements OnInit {
  public id;
  public selectedValue;
  public ranksArray=[];
  public ranks = {
    low:0,
    high:0,
  }

  public barsicRanksForm = this.fb.group({
    vlowl:[''],
    vlowh:[''],
    lowl:[''],
    lowh:[''],
    midl:[''],
    midh:[''],
    highl:[''],
    highh:[''],
    vhighl:[''],
    vhighh:[''],
  })

  public barsicRanksPrimaryForm = this.fb.group({
    vlowl:[''],
    vlowh:[''],
    lowl:[''],
    lowh:[''],
    midl:[''],
    midh:[''],
    highl:[''],
    highh:[''],
    vhighl:[''],
    vhighh:[''],
  })


  public barsicRanksSecondaryForm = this.fb.group({
    vlowl:[''],
    vlowh:[''],
    lowl:[''],
    lowh:[''],
    midl:[''],
    midh:[''],
    highl:[''],
    highh:[''],
    vhighl:[''],
    vhighh:[''],
  })


  public barsicFactorForm = this.fb.group({
    veryLowDesc: [''],
    lowDesc: [''],
    midDesc: [''],
    highDesc: [''],
    veryHighDesc: [''],
    name: [''],
  })

  constructor(private fb:FormBuilder, private barsicService:BarsicService) {
    this.barsicService.getRanks().subscribe(
      resp=>{
        if(resp.length>0) {
          this.id == resp[0]._id;
          this.barsicRanksForm.addControl('_id', new FormControl(resp[0]._id));
          this.barsicRanksForm.addControl('__v', new FormControl(resp[0].__v));
          this.barsicRanksForm.setValue(resp[0]);
          var ranks = resp[0]
        
          this.barsicRanksForm.get('vlowl').setValue(ranks.vlowl);
          this.barsicRanksForm.get('vlowh').setValue(ranks.vlowh);

          this.barsicRanksForm.get('lowl').setValue(ranks.lowl);
          this.barsicRanksForm.get('lowh').setValue(ranks.lowh);

          this.barsicRanksForm.get('midl').setValue(ranks.midl);
          this.barsicRanksForm.get('midh').setValue(ranks.midh);

          this.barsicRanksForm.get('highl').setValue(ranks.highl);
          this.barsicRanksForm.get('highh').setValue(ranks.highh);

          this.barsicRanksForm.get('vhighl').setValue(ranks.vhighl);
          this.barsicRanksForm.get('vhighh').setValue(ranks.vhighh);
          
        }
      },
      err=>console.log(err)
    )

    this.barsicService.getPrimaryRanks().subscribe(
      resp=>{
        if(resp.length>0) {
          this.id == resp[0]._id;
          this.barsicRanksPrimaryForm.addControl('_id', new FormControl(resp[0]._id));
          this.barsicRanksPrimaryForm.addControl('__v', new FormControl(resp[0].__v));
          this.barsicRanksPrimaryForm.setValue(resp[0]);
          var ranks = resp[0]
        
          this.barsicRanksPrimaryForm.get('vlowl').setValue(ranks.vlowl);
          this.barsicRanksPrimaryForm.get('vlowh').setValue(ranks.vlowh);

          this.barsicRanksPrimaryForm.get('lowl').setValue(ranks.lowl);
          this.barsicRanksPrimaryForm.get('lowh').setValue(ranks.lowh);

          this.barsicRanksPrimaryForm.get('midl').setValue(ranks.midl);
          this.barsicRanksPrimaryForm.get('midh').setValue(ranks.midh);

          this.barsicRanksPrimaryForm.get('highl').setValue(ranks.highl);
          this.barsicRanksPrimaryForm.get('highh').setValue(ranks.highh);

          this.barsicRanksPrimaryForm.get('vhighl').setValue(ranks.vhighl);
          this.barsicRanksPrimaryForm.get('vhighh').setValue(ranks.vhighh);
          
        }
      },
      err=>console.log(err)
    )

    this.barsicService.getSecondaryRanks().subscribe(
      resp=>{
        if(resp.length>0) {
          this.id == resp[0]._id;
          this.barsicRanksSecondaryForm.addControl('_id', new FormControl(resp[0]._id));
          this.barsicRanksSecondaryForm.addControl('__v', new FormControl(resp[0].__v));
          this.barsicRanksSecondaryForm.setValue(resp[0]);
          var ranks = resp[0]
        
          this.barsicRanksSecondaryForm.get('vlowl').setValue(ranks.vlowl);
          this.barsicRanksSecondaryForm.get('vlowh').setValue(ranks.vlowh);

          this.barsicRanksSecondaryForm.get('lowl').setValue(ranks.lowl);
          this.barsicRanksSecondaryForm.get('lowh').setValue(ranks.lowh);

          this.barsicRanksSecondaryForm.get('midl').setValue(ranks.midl);
          this.barsicRanksSecondaryForm.get('midh').setValue(ranks.midh);

          this.barsicRanksSecondaryForm.get('highl').setValue(ranks.highl);
          this.barsicRanksSecondaryForm.get('highh').setValue(ranks.highh);

          this.barsicRanksSecondaryForm.get('vhighl').setValue(ranks.vhighl);
          this.barsicRanksSecondaryForm.get('vhighh').setValue(ranks.vhighh);
          
        }
      },
      err=>console.log(err)
    )
   }

  ngOnInit(): void {
  }

  register(){
    this.barsicService.createFactor(this.barsicFactorForm.value).subscribe(
      resp=>{
        this.barsicFactorForm.reset();
        let timerInterval
        Swal.fire({
          title: 'Factor creado',
          html: '',
          timer: 1000,
          timerProgressBar: true,
          willOpen: () => {
            Swal.showLoading()
          },
          onClose: () => {
            clearInterval(timerInterval)
          }
        }).then((result) => {
          /* Read more about handling dismissals below */
          if (result.dismiss === Swal.DismissReason.timer) {
            
          }
        })
      },
      err=>{
        console.log(err)
      }
    )
  }

  addRank(){
    if(this.selectedValue=='Deficiente Inferior'){
      this.barsicRanksForm.get('vlowl').setValue(this.ranks.low);
      this.barsicRanksForm.get('vlowh').setValue(this.ranks.high);
    }
    if(this.selectedValue=='Medio Medio'){
      this.barsicRanksForm.get('lowl').setValue(this.ranks.low);
      this.barsicRanksForm.get('lowh').setValue(this.ranks.high);
    }    
    if(this.selectedValue=='Medio Superior'){
      this.barsicRanksForm.get('midl').setValue(this.ranks.low);
      this.barsicRanksForm.get('midh').setValue(this.ranks.high);
    }    
    if(this.selectedValue=='Superior'){
      this.barsicRanksForm.get('highl').setValue(this.ranks.low);
      this.barsicRanksForm.get('highh').setValue(this.ranks.high);
    }    
    if(this.selectedValue=='Excelente'){
      this.barsicRanksForm.get('vhighl').setValue(this.ranks.low);
      this.barsicRanksForm.get('vhighh').setValue(this.ranks.high);
    }

    this.barsicService.updateRanks(this.barsicRanksForm.value, 'normal').subscribe(
      resp=>{
        window.location.reload();
      },
      err=>console.log(err)
    )

  }

  addRankSecondary(){

    if(this.selectedValue=='Muy inferior'){
      this.barsicRanksSecondaryForm.get('vlowl').setValue(this.ranks.low);
      this.barsicRanksSecondaryForm.get('vlowh').setValue(this.ranks.high);
    }
    if(this.selectedValue=='Inferior'){
      this.barsicRanksSecondaryForm.get('lowl').setValue(this.ranks.low);
      this.barsicRanksSecondaryForm.get('lowh').setValue(this.ranks.high);
    }    
    if(this.selectedValue=='Mediano'){
      this.barsicRanksSecondaryForm.get('midl').setValue(this.ranks.low);
      this.barsicRanksSecondaryForm.get('midh').setValue(this.ranks.high);
    }    
    if(this.selectedValue=='Superior'){
      this.barsicRanksSecondaryForm.get('highl').setValue(this.ranks.low);
      this.barsicRanksSecondaryForm.get('highh').setValue(this.ranks.high);
    }    
    if(this.selectedValue=='Excelente'){
      this.barsicRanksSecondaryForm.get('vhighl').setValue(this.ranks.low);
      this.barsicRanksSecondaryForm.get('vhighh').setValue(this.ranks.high);
    }

    this.barsicService.updateRanks(this.barsicRanksSecondaryForm.value, 'secondary').subscribe(
      resp=>{
        window.location.reload();
      },
      err=>console.log(err)
    )

  }

  addRankPrimary(){

    if(this.selectedValue=='Muy inferior'){
      this.barsicRanksPrimaryForm.get('vlowl').setValue(this.ranks.low);
      this.barsicRanksPrimaryForm.get('vlowh').setValue(this.ranks.high);
    }
    if(this.selectedValue=='Inferior'){
      this.barsicRanksPrimaryForm.get('lowl').setValue(this.ranks.low);
      this.barsicRanksPrimaryForm.get('lowh').setValue(this.ranks.high);
    }    
    if(this.selectedValue=='Mediano'){
      this.barsicRanksPrimaryForm.get('midl').setValue(this.ranks.low);
      this.barsicRanksPrimaryForm.get('midh').setValue(this.ranks.high);
    }    
    if(this.selectedValue=='Superior'){
      this.barsicRanksPrimaryForm.get('highl').setValue(this.ranks.low);
      this.barsicRanksPrimaryForm.get('highh').setValue(this.ranks.high);
    }    
    if(this.selectedValue=='Excelente'){
      this.barsicRanksPrimaryForm.get('vhighl').setValue(this.ranks.low);
      this.barsicRanksPrimaryForm.get('vhighh').setValue(this.ranks.high);
    }

    this.barsicService.updateRanks(this.barsicRanksPrimaryForm.value, 'primary').subscribe(
      resp=>{
        window.location.reload();
      },
      err=>console.log(err)
    )

  }

}

